import React, { Component } from 'react'
import * as R from 'ramda'
import './matrix.scss'

class MatrixChart extends Component {
    constructor(props) {
        super(props)
        this.containerRef = React.createRef()
        this.state = {
            height: 0,
        }
    }

    componentDidMount() {
        this.updateHeight()
    }

  updateHeight = () => {
      if (this.containerRef.current) {
          const newHeight = this.containerRef.current.offsetHeight
          this.setState({ height: newHeight })
      }
  };

    renderDataBlocks = (data, quadrantIndex) => {
        const { compact } = this.props
        return (
            <div className={`dataBlock ${data.name} quadrant-${quadrantIndex}`}>
                <div className="dataContainer">
                    <div className="mainData" style={!compact ? { flex: '50%' } : {}}>
                        <div className="mainText">
                            {data.value}
                        </div>
                        <div className="subText">
                            {data.name}
                        </div>
                    </div>
                    {
                        compact || !R.pathOr([], ['benchmarks'], data).length ? null
                            : (
                                <div className="benchmarkData" style={!compact ? { flex: '50%' } : {}}>
                                    {R.pathOr([], ['benchmarks'], data).map((b) => (
                                        <div className="benchmark">
                                            <div className="benchmarkName">{b.name}</div>
                                            <div className="benchmarkValue">{b.value}</div>
                                        </div>
                                    ))}
                                </div>
                            )
                    }
                </div>
            </div>
        )
    }

    render() {
        const {
            style, chartData, matrixAxisNames, containerSize, preview,
        } = this.props
        const { height } = this.state
        const yLabelWidth = preview ? height : R.pathOr(height + 125, ['height'], containerSize) - 125

        return (
            <div className="matrix" style={{ height: '400px', width: '500px', ...style }}>
                <div className="matrixContainer">
                    <div className="matrixGraph" ref={this.containerRef}>
                        <div className="yLabel" style={{ width: `${yLabelWidth}px`, textAlign: 'center' }}>
                            {R.pathOr('Loyalty', ['y'], matrixAxisNames)}
                        </div>
                        <div className="xLabel">{R.pathOr('Satisfaction', ['x'], matrixAxisNames)}</div>
                        {chartData[0] ? this.renderDataBlocks(chartData[0], 0) : null}
                        {chartData[1] ? this.renderDataBlocks(chartData[1], 1) : null}
                        {chartData[2] ? this.renderDataBlocks(chartData[2], 2) : null}
                        {chartData[3] ? this.renderDataBlocks(chartData[3], 3) : null}
                    </div>
                </div>
            </div>
        )
    }
}

export default MatrixChart
